
import { foreignProps } from 'vessel/utils'

import Form from './Form'
const form = foreignProps(Form)

export default {
  inheritAttrs: false,
  props: {
    ...form.props,
    text: {
      type: String,
      default() {
        return this.$t('site.contact.sendMessage')
      }
    },
    modalTitle: {
      type: String,
      default: null
    },
    modalSize: {
      type: [String, Object],
      default: 'mini'
    }
  },
  data() {
    return {
      visible: false
    }
  },
  computed: {
    formAttrs() {
      return form.fetch(this.$props)
    }
  }
}
